import Icon from "assets/icons";
import { useFormikContext } from "formik";
import React from "react";
import FormTextField from "shared/form/fields/textField";
import { useGetCaptcha } from "./dataloader";
import Button from "../../../../shared/components/button";
import Validation from "shared/form/Validation";
import FieldIdentifier from "../../../../shared/form/renderer/enums/FieldIdentifier";
import { useCopies } from "shared/hooks/useCopies";

/**
 * @todo
 * 1. SR test css after text field and icon button css is added
 * 2. Move all Strings to en.json
 */

export default function CaptchaComponent(props: CaptchaConfig) {
  const copies = useCopies();
  const { setFieldValue } = useFormikContext();

  const onSuccessHandler = React.useCallback(
    data => {
      setFieldValue(FieldIdentifier.CAPTCHA_ID, data.id);
      setFieldValue(FieldIdentifier.CAPTCHA_TEXT, "");
    },
    [setFieldValue]
  );

  const { data: captchaResObj, refetch } = useGetCaptcha(onSuccessHandler);

  const validateFn = React.useCallback(
    e =>
      Validation.captchaValidation({
        copies: copies,
        required: props.required,
        requiredMsg: copies.get("captcha.invalid")
      })
        .validate(e)
        .then(() => undefined)
        .catch(({ errors }: any) => errors[0]),
    [props.required, copies]
  );

  return (
    <div className="captcha_wrapper">
      <div className="captcha">
        <div className="captcha_image">
          {captchaResObj?.captchaImage && (
            <img src={`data:image/png;base64,${captchaResObj.captchaImage}`} alt="captcha" />
          )}
          <Button
            className="captcha_refresh"
            title={copies.get("reload")}
            icon={<Icon.Refresh />}
            onClick={() => {
              refetch();
            }}
          />
        </div>
        <div className="captcha_input_wrapper">
          <FormTextField
            name={FieldIdentifier.CAPTCHA_TEXT}
            placeholder={copies.get("captcha.input.placeholder")}
            fullWidth
            validate={validateFn}
            required={props.required}
            autoComplete="off"
            label={""}
          />
        </div>
      </div>
    </div>
  );
}
